import { getCsrfValue } from "../../api/ApiHelper";
import { resolveApiUrl } from "../../utils/url/urlResolver";

export interface ResponseData {
  globalErrors: string[];
  validationResults: FieldValidationResults;
}

export type FieldValidationResults = {
  [fieldName: string]: string[] | undefined;
};

interface Props {
  pwd: string;
  checkPwd: string;
  token: string;
  newCustomer: boolean;
}

const apiUrl = resolveApiUrl("/login/pw/change");

export function sendUpdatePasswordRequest(data: Props): Promise<ResponseData> {
  const params = new URLSearchParams();
  params.set("pwd", data.pwd);
  params.set("checkPwd", data.checkPwd);
  params.set("token", data.token);
  if (data.newCustomer) {
    params.set("newCustomer", "true");
  }

  return fetch(apiUrl, {
    body: params.toString(),
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/x-www-form-urlencoded",
      CSRFToken: getCsrfValue(),
    },
    redirect: "follow",
  }).then((response) => {
    if (!response.ok) {
      throw new Error("Error setting password");
    }
    return response.json() as Promise<ResponseData>;
  });
}
